import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getShipments } from '@actions';

const useShipments = (filter = {}) => {
  const dispatch = useDispatch();
  const { shipments } = useSelector((state) => state.globals);

  useEffect(() => {
    dispatch(getShipments());
  }, [dispatch]);

  const filters = Object.entries(filter);

  return shipments.filter((shipment) =>
    filters.every(([key, val]) => shipment[key] === val)
  );
};

export default useShipments;
